<template>
  <div class="acupoint">
    <el-button icon="el-icon-refresh" @click="$refresh(getAcupointsList)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="名称">
            <el-input v-model.trim="searchForm.acupointName" placeholder="请输入穴位名称"/>
          </el-form-item>
          <el-form-item label="所在经脉">
            <el-select v-model="searchForm.species" filterable default-first-option placeholder="请选择所在经脉">
              <el-option v-for="item in speciesOptions" :key="item" :value="item"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getAcupointsList, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getAcupointsList, { acupointName: null, species: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <!-- <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addAcupoint">新增穴位</el-button>
      </div> -->
      <!-- 穴位列表 -->
      <el-table v-loading="loading" :max-height="tableHeight" :data="acupointList" border>
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="acupointName" label="穴位名称"/>
        <el-table-column prop="initials" label="穴位首拼"/>
        <el-table-column prop="type" label="类型" :formatter="formatterType"/>
 />
        <el-table-column prop="species" label="所在经脉"/>
        <el-table-column prop="updateBy" label="操作员"/>
        <el-table-column prop="createTime" label="录入时间" min-width="150"/>
        <!-- <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" type="primary" @click="editAcupoint(scope.row)">编辑</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="350px" :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="穴位名称" prop="acupointName">
            <el-input v-model.trim="editForm.acupointName" placeholder="请输入穴位名称"/>
          </el-form-item>
          <el-form-item label="所在经脉" prop="species">
            <el-select v-model="editForm.species" filterable default-first-option placeholder="请选择所在经脉">
              <el-option v-for="item in speciesOptions" :key="item" :value="item"/>
            </el-select>
          </el-form-item>
          <el-form-item label="穴位类型" prop="type">
            <el-select v-model="editForm.type" placeholder="请选择穴位类型">
              <el-option v-for="item in ['单','双']" :key="item" :value="item"/>
            </el-select>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增穴位'" @click="addSave">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑穴位'" @click="editSave">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getAcupointsList)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </div>
</template>

<script lang="js">
import { acupointList, acupointEdit, acupointAdd } from "@/api/acupoint"; // 穴位请求
import { dictText } from '@/utils/validateBase';

export default {
  data() {
    return {
      loading: true, // 加载中
      searchForm: { acupointName: null, species: null }, // 查询表单
      acupointList: [], // 穴位列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      speciesOptions: this.$speciesOptions, // 所在经脉
      editFormRules: {
        acupointName: [{required: true, message: "穴位名称", trigger: "blur"}],
        species: [{required: true, message: "穴位所在经脉不能为空", trigger: "change"}],
        type: [{required: true, message: "穴位类型不能为空", trigger: "change"}]
      }, // 验证规则
      tableHeight: 0, // 表格最大高度
      acupointType: [
        { label: '单', value: 10 },
        { label: '双', value: 20 },
        { label: '左', value: 30 },
        { label: '右', value: 40 },
        { label: '自定义数量', value: 50 },
        { label: '四缝穴', value: 60 },
      ],
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 280;
    this.getAcupointsList(); // 页面初始化获取穴位列表
  },
  methods: {
    // 请求所有穴位列表
    async getAcupointsList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await acupointList(params);
      
      if (code == 200) {
        this.total = total;
        this.acupointList = rows;
      }
      this.loading = false;
    },
    // 新增穴位
    addAcupoint() {
      this.dialogVisible = true;
      this.dialogTitle = "新增穴位";
      this.editForm = { acupointName: null, type: null, species: null };
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          acupointAdd(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("新增穴位成功！");

            this.dialogVisible = false;
            this.$refresh(this.getAcupointsList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 编辑穴位信息
    async editAcupoint(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.dialogTitle = "编辑穴位";
      this.dialogVisible = true;
    },
    // 保存穴位修改
    async editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          acupointEdit(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("修改穴位成功！");

            this.dialogVisible = false;
            this.$refresh(this.getAcupointsList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    formatterType(row){
      return dictText(row.type, this.acupointType)
    }
  },
};
</script>

<style lang="less" scoped>
  .acupoint {
    box-sizing: border-box;
    padding: 20px;
  }
</style>